/**
 * PublicFooter
 * 
 * Footer component for public pages with contact info and policy links.
 * Used on landing page and policy pages.
 */

import { Link } from 'react-router-dom'
import { BRANDING } from '../../config/branding'
import './PublicFooter.css'

export function PublicFooter() {
  const currentYear = new Date().getFullYear()
  
  return (
    <footer className="public-footer">
      <div className="public-footer__container">
        <div className="public-footer__brand">
          <span className="public-footer__logo">{BRANDING.name}</span>
          <p className="public-footer__tagline">{BRANDING.footer}</p>
        </div>
        
        <div className="public-footer__links">
          <div className="public-footer__section">
            <h4>Contact</h4>
            <a href="mailto:support@plotplanet.com">support@plotplanet.com</a>
            <a href="mailto:hello@plotplanet.com">hello@plotplanet.com</a>
          </div>
          
          <div className="public-footer__section">
            <h4>Legal</h4>
            <Link to="/terms">Terms of Service</Link>
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/refunds">Refund Policy</Link>
            <Link to="/cancellation">Cancellation Policy</Link>
          </div>
        </div>
        
        <div className="public-footer__bottom">
          <p>&copy; {currentYear} {BRANDING.name}. All rights reserved.</p>
        </div>
      </div>
    </footer>
  )
}

export default PublicFooter
